






















import { Component, Prop, Vue } from "vue-property-decorator";
import { UserData } from "@/../api/data";
import voteStore from "@/../api/vote.store";
import userStore from "@/../api/user.store";
import Gravatar from "./Gravatar.vue";

@Component({ components: { Gravatar } })
export default class UserCard extends Vue {
  @Prop(String) userId: string;
  @Prop(String) roomName: string;

  userData: UserData | undefined = userStore.user(this.userId);
  userVote = voteStore.userVote(this.roomName, this.userId);

  /*
   * Hack to set the order in flex. Uses the "ASCII" representation of the number
   * normalized so a = 11 and names with less letters are padded with trailing 10s.
   * Can use at most 4 characters because of the limit on the max number for order.
   */
  calculateOrder(name: string) {
    const baseCharCode = "a".charCodeAt(0);
    const nameToUse =
      name.length > 4
        ? name.toLowerCase().substring(0, 4)
        : name.toLowerCase().padEnd(4, String.fromCharCode(baseCharCode - 1));
    return nameToUse
      .split("")
      .map(c => c.charCodeAt(0) - baseCharCode + 11)
      .map(n => n.toString())
      .join("");
  }
}
